import { SWRConfiguration } from 'swr';

import { CompanyEquipmentType } from '~/data/equipment/types';
import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

const SWR_KEY_useGetCompanyEquipment = 'getCompanyEquipment';

export const getCompanyEquipment = async (): Promise<
  CompanyEquipmentType[]
> => {
  return fetchFromOldApi(`/json/company/equipment`).then((r) => r.json());
};

export const useGetCompanyEquipment = (
  swrConfig?: SWRConfiguration<CompanyEquipmentType[]>,
  isDisabled?: boolean,
): UseArraySWROutput<CompanyEquipmentType> => {
  return useArraySWR(
    !isDisabled ? [SWR_KEY_useGetCompanyEquipment] : null,
    ([_key]: [string]) => {
      return getCompanyEquipment();
    },
    swrConfig,
  );
};
